module.exports = __webpack_public_path__ + "img/bg-face1.png";